import React from "react";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import PersonIcon from "@mui/icons-material/Person";
import { Link } from "react-router-dom";
import StarIcon from "@mui/icons-material/Star";
import Flip from "react-reveal/Flip";

function ExperienceJourney() {
  return (
    <div className="mt-5">
      <div>
        <Link className="btn btn-primary m-1" to="/educationjourney">
          Educational Journey
        </Link>
        {/* <Link className="btn btn-primary m-1" to="/experiencejourney">
          Experience Journey
        </Link> */}
        {/* <Link className="btn btn-primary m-1" to="/technicaljourney">
          Technical Journey
        </Link>
        <Link className="btn btn-primary m-1" to="/projectjourney">
          Project Journey
        </Link> */}
      </div>
      <div className="mt-5">
        <Flip top cascade>
          <h1>Experience Journey</h1>
        </Flip>
      </div>
      <VerticalTimeline>
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          contentStyle={{ background: "rgb(78 22 112)", color: "#fbd9ad", marginLeft:20}}
          contentArrowStyle={{ borderRight: "7px solid  rgb(78 22 112)" }}
          date="Jul 2025 - Jan 2026"
          iconStyle={{ background: "rgb(78 22 112)", color: "#fbd9ad" }}
          icon={<PersonIcon />}
        >
          <h5 className="vertical-timeline-element-title">
          React Native Developer (Full-Stack)
          </h5>
          <h6 className="vertical-timeline-element-subtitle mt-2">
          SDLC Corp, India — On-site
          </h6>
          <p>• Built and shipped features for a live App Store app (<a href="https://apps.apple.com/in/app/audience-pool/id6747374898" target="_blank" rel="noreferrer" style={{color: "inherit", textDecoration: "none"}} className="purple">Audience Pool</a>) across React Native mobile and React.js / Next.js web.</p>
          <p>• Reduced average screen load time by 30% via lazy loading, performance tuning, and Redux Toolkit state management.</p>
          <p>• Architected backend with Node.js + Express.js + MongoDB (MVC); designed RESTful APIs for both mobile and web clients.</p>
          <p>• Integrated AI features via prompt engineering to automate workflows; cut post-release bugs by 15% working with QA.</p>
 
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          contentStyle={{ background: "rgb(78 22 112)", color: "#fbd9ad", marginLeft:20}}
          contentArrowStyle={{ borderRight: "7px solid  rgb(78 22 112)" }}
          date="May 2024 - Oct 2024"
          iconStyle={{ background: "rgb(78 22 112)", color: "#fbd9ad" }}
          icon={<PersonIcon />}
        >
          <h5 className="vertical-timeline-element-title">
          App Developer (TypeScript & React Native)
          </h5>
          <h6 className="vertical-timeline-element-subtitle mt-2">
          Nurtureheal Healthcare Pvt. Ltd. — Remote
          </h6>
          <p>• Delivered core features for a healthcare mobile platform using TypeScript; improved reliability and reduced runtime errors.</p>
          <p>• Improved UX and navigation flows, increasing average session duration by 20%.</p>
          <p>• Integrated third-party REST APIs (payment, health data); built form validation with Formik + Yup; managed state with Redux.</p>
 
        </VerticalTimelineElement>

        <VerticalTimelineElement
          iconStyle={{ background: "#fbd9ad", color: "rgb(78 22 112)" }}
          icon={<StarIcon />}
        />
      </VerticalTimeline>
    </div>
  );
}

export default ExperienceJourney;
